import React, { useReducer } from 'react';
import { Redirect } from 'react-router-dom';

import AuthenticationDispatch from '../../contexts/authenticationDispatch';
import authenticationReducer from '../../reducers/authentication.reducer';

import ForgotPasswordForm from './ForgotPasswordForm';
import style from './ForgotPasswordPage.module.css';

const ForgotPasswordPage = React.memo(() => {
  const [state, dispatch] = useReducer(authenticationReducer, {
    resetPasswordRequested: false,
  });

  const { resetPasswordRequested } = state;

  return !resetPasswordRequested ? (
    <AuthenticationDispatch.Provider value={dispatch}>
      <section className={style.forgotPassword}>
        <h2 className={style.h2}>
          Please enter your email address and a link will be sent to reset
          password
        </h2>
        <div className={`container ${style.container}`}>
          <div className={style.wrapper}>
            <ForgotPasswordForm />
          </div>
        </div>
      </section>
    </AuthenticationDispatch.Provider>
  ) : (
    <Redirect to="/login/forgot-password/thank-you" />
  );
});

export default ForgotPasswordPage;
